const _excluded = ["userSelectedSorting"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}import { actions } from "../../BasicReducer";
import libraryHelpers from "./libraryFilters";
import api from "../../Search/SearchAPI";
import prioritySortingCriteria from "../../utils/prioritySortingCriteria";
import rison from 'rison-node';
import { getThesaurusPropertyNames } from "../../../shared/commonTopicClassification";
import { setTableViewColumns } from "../actions/libraryActions";
import { tocGenerationUtils } from "../../ToggledFeatures/tocGeneration";
import { wrapDispatch } from "../../Multireducer";
import { UserRole } from "../../../shared/types/userSchema";
import { getTableColumns } from "./tableColumns";
import setReduxState from "./setReduxState.js";

const decodeQuery = (params) => {
  try {
    return rison.decode(params.q || '()');
  } catch (error) {
    error.status = 404;
    throw error;
  }
};

const processQuery = (params, globalResources, key) => {var _globalResources$key$;
  const defaultSearch = prioritySortingCriteria.get({ templates: globalResources.templates });

  let query = decodeQuery(params);

  query = Object.assign(query, {
    order: query.order || defaultSearch.order,
    sort: query.sort || defaultSearch.sort,
    view: params.view
  });

  const noDocuments = !globalResources[key] || !((_globalResources$key$ = globalResources[key].documents) !== null && _globalResources$key$ !== void 0 && _globalResources$key$.get('rows').size);

  if (noDocuments && query.limit) {
    query = Object.assign(query, { limit: query.limit + (query.from || 0), from: 0 });
  }

  const { userSelectedSorting } = query,sanitizedQuery = _objectWithoutProperties(query, _excluded);

  const loggedIn = globalResources.user && globalResources.user.has('role');
  const isAdmin = loggedIn && globalResources.user.get('role') === UserRole.ADMIN;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({},
  tocGenerationUtils.aggregations(sanitizedQuery, globalResources.settings.collection.toJS())),
  loggedIn ? { aggregatePublishingStatus: true } : {}),
  loggedIn && !isAdmin ? { aggregatePermissionsByLevel: true } : {}),
  isAdmin ? { aggregatePermissionsByUsers: true } : {});

};

const requestState = (
requestParams,
globalResources,
options = { calculateTableColumns: false, geolocation: false }) =>
{
  const docsQuery = processQuery(requestParams.data, globalResources, 'library');

  const documentsRequest = requestParams.set(
    tocGenerationUtils.aggregations(docsQuery, globalResources.settings.collection.toJS())
  );

  const markersRequest = options.geolocation ?
  api.search(
    requestParams.set(_objectSpread(_objectSpread({},
    docsQuery), {}, {
      geolocation: true })
    )
  ) :
  { rows: [] };

  return Promise.all([api.search(documentsRequest), markersRequest]).then(
    ([documents, markers]) => {
      const useDefaultPublishedStatus =
      !documentsRequest.data.includeUnpublished && !documentsRequest.data.unpublished;
      const templates = globalResources.templates.toJS();
      const filterState = libraryHelpers.URLQueryToState(_objectSpread(_objectSpread({},

      documentsRequest.data),
      useDefaultPublishedStatus && { includeUnpublished: false, unpublished: false }),

      templates,
      requestParams.data.quickLabelThesaurus ?
      getThesaurusPropertyNames(requestParams.data.quickLabelThesaurus, templates) :
      []
      );

      const state = {
        library: {
          filters: {
            documentTypes: documentsRequest.data.types || [],
            properties: filterState.properties
          },
          aggregations: documents.aggregations,
          search: filterState.search,
          documents,
          markers
        }
      };

      const addinsteadOfSet = Boolean(docsQuery.from);

      const dispatchedActions = [
      setReduxState(state, 'library', addinsteadOfSet),
      actions.set('library.sidepanel.quickLabelState', {
        thesaurus: requestParams.data.quickLabelThesaurus,
        autoSave: false
      })];

      if (options.calculateTableColumns) {
        const tableViewColumns = getTableColumns(documents, templates, documentsRequest.data.types);
        dispatchedActions.push((dispatch) =>
        wrapDispatch(dispatch, 'library')(setTableViewColumns(tableViewColumns))
        );
      }
      return dispatchedActions;
    }
  );
};

export { decodeQuery, processQuery, requestState };